import { css } from 'styled-components';
export const focusOutline = ({ theme }) => {
    var _a;
    return css `
  &:focus {
    outline: none;
  }

  &[data-focus-visible-added]:focus {
    box-shadow: ${(_a = theme.focusOutline) === null || _a === void 0 ? void 0 : _a.boxShadow};
    z-index: 1;
  }
`;
};
//# sourceMappingURL=focusOutline.js.map